export default __webpack_public_path__ + "static/media/gear.12a6d7d0.svg";